import { reduxForm, SubmissionError } from "redux-form";

import * as actions from "../constants/actions";
import SecuritySigninForm from "../components/forms/SecuritySigninForm";

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.securitySignin({ values, resolve, reject }));
  }).catch(error => {
    throw new SubmissionError({ _error: error });
  });
};

export default reduxForm({
  form: "securitySignin",
  onSubmit
})(SecuritySigninForm);



// WEBPACK FOOTER //
// ./src/containers/SecuritySigninForm.js